"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeRedirect = sanitizeRedirect;
/**
 * Sanitizes a redirect URL from search params. Returns only safe, relative paths:
 * - Starts with exactly one '/' (not '//' protocol-relative)
 * - No scheme (://)
 * - No suspicious characters (newline, etc.)
 * Otherwise returns undefined.
 */
function sanitizeRedirect(value) {
    if (typeof value !== 'string' || !value)
        return undefined;
    const trimmed = value.trim();
    if (!trimmed)
        return undefined;
    let decoded;
    try {
        decoded = decodeURIComponent(trimmed);
    }
    catch {
        return undefined;
    }
    const decodedTrimmed = decoded.trim();
    // Must start with exactly one '/', not '//' (protocol-relative)
    if (!decodedTrimmed.startsWith('/') || decodedTrimmed.startsWith('//'))
        return undefined;
    // Must not contain scheme (://)
    if (decodedTrimmed.includes('://'))
        return undefined;
    // Must not contain suspicious characters (newline, etc.)
    if (/[\r\n]/.test(decodedTrimmed))
        return undefined;
    return decodedTrimmed;
}
//# sourceMappingURL=route.js.map